(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendation"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);



const productRecommendationsSection = document.querySelector('.cart-recommendations');
fetch(this.dataset.url)
 .then(response => response.text())
 .then((text) => {
    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('.cart-recommendations');

    if (recommendations && recommendations.innerHTML.trim().length) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
    }
 });





      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('cart-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-blog-slider"] && !Shopify.designMode) return;
  try {
    
      $(".blog_card_slider_section").slick({
    arrow:true,
   slidesToShow: 4,
   infinite:false,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   responsive: [
    {
      breakpoint:991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint:749,
      settings: {
        arrow:false,
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
  ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collecion-with-tabs"] && !Shopify.designMode) return;
  try {
    
    //Swap the collection shown as best seller on first
$(document).on('click', '[data-best-sellr-selector-first]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var section_id = $(this).attr("data-section-id");
  console.log("section_id",section_id);
  var contentFirst = $(`#${section_id} [data-best-sellr-collection-first]`);
  var selectorFirst = $(`#${section_id} [data-best-sellr-selector-first]`);
  var contentSecond = $(`#${section_id} [data-best-sellr-collection-second]`);
  var selectorSecond = $(`#${section_id} [data-best-sellr-selector-second]`);
  console.log(contentFirst);

  contentFirst.addClass('is-visible');
  contentSecond.removeClass('is-visible');
  selectorFirst.addClass('is-active');
  selectorSecond.removeClass('is-active');
});

//Swap the collection shown as best seller on second
$(document).on('click', '[data-best-sellr-selector-second]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var section_id = $(this).attr("data-section-id");
  console.log("section_id",section_id);
  var contentFirst = $(`#${section_id} [data-best-sellr-collection-first]`);
  var selectorFirst = $(`#${section_id} [data-best-sellr-selector-first]`);
  var contentSecond = $(`#${section_id} [data-best-sellr-collection-second]`);
  var selectorSecond = $(`#${section_id} [data-best-sellr-selector-second]`);
  console.log(contentFirst);
  contentFirst.removeClass('is-visible');
  contentSecond.addClass('is-visible');
  selectorFirst.removeClass('is-active');
  selectorSecond.addClass('is-active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  $(".testimonial_slider_section").slick({
   slidesToShow: 1,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
    arrows: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);



const productRecommendationsSection = document.querySelector('.product-recommendations');
fetch(this.dataset.url)
 .then(response => response.text())
 .then((text) => {
    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('.product-recommendations');

    if (recommendations && recommendations.innerHTML.trim().length) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
    }
 });





      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-article"] && !Shopify.designMode) return;
  try {
    
      $(".blog_card_slider_section").slick({
    arrow:true,
   slidesToShow: 3,
   infinite:false,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   responsive: [
    {
      breakpoint:991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint:749,
      settings: {
        arrow:false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
      }
    }
  ]
  });

  } catch(e) { console.error(e); }
})();
})();
